import db from './db';

const PLANTNET_API_URL = 'https://my-api.plantnet.org/v2/identify/all';

/**
 * Identify a plant using the PlantNet API.
 * @param {File[]} images - Array of image files to send
 * @param {string} apiKey - PlantNet API key
 * @param {string[]} [organs] - Organ type per image ('leaf', 'flower', 'fruit', 'bark', 'auto')
 * @returns {Promise<object>} API response with results
 */
export async function identifyPlant(images, apiKey, organs = []) {
  const formData = new FormData();

  images.forEach((image, i) => {
    formData.append('images', image);
    formData.append('organs', organs[i] || 'auto');
  });

  const url = `${PLANTNET_API_URL}?api-key=${encodeURIComponent(apiKey)}&include-related-images=true`;

  const res = await fetch(url, {
    method: 'POST',
    body: formData,
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`PlantNet API error: ${res.status} ${text}`);
  }

  return res.json();
}

/**
 * Save an identification result to IndexedDB for history.
 */
export async function saveIdentification(result) {
  const record = {
    id: crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(),
    timestamp: new Date().toISOString(),
    selectedSpecies: result.selectedSpecies || null,
    results: result.results || [],
    imageCount: result.imageCount || 0,
    images: result.images || [], // Array of { key, name, type } referencing S3 objects
    query: result.query || {},
  };
  await db.identifications.put(record);
  return record;
}

/**
 * Get all saved identifications, newest first.
 */
export async function getIdentifications() {
  return db.identifications.orderBy('timestamp').reverse().toArray();
}

/**
 * Delete an identification record.
 */
export async function deleteIdentification(id) {
  await db.identifications.delete(id);
}
